import { useState, useEffect } from 'react';
import { twMerge } from '@belong/common';
import { Image, Text } from '@belong/ui';
import styles from './interested-popup.module.css';
import { INTERESTED_POPUP_STRINGS } from './interested-popup.strings';

const POPUP_DELAY = 2000;
const POPUP_DISPLAY_DURATION = 45000;

type InterestedPopupProps = {
  numberOfInterested: number;
};

export function InterestedPopup({ numberOfInterested }: InterestedPopupProps) {
  const [popupVisible, setPopupVisible] = useState(false);
  const [hidePopup, setHidePopup] = useState(false);

  function showPopUp() {
    setPopupVisible(true);

    setTimeout(() => {
      setPopupVisible(false);
      setHidePopup(true);
    }, POPUP_DISPLAY_DURATION);
  }

  useEffect(() => {
    const popupTimeout = setTimeout(() => {
      showPopUp();
    }, POPUP_DELAY);

    return () => {
      clearTimeout(popupTimeout);
    };
  }, []);

  return (
    <div
      className={twMerge(
        'fixed text-white bg-dark-navy-translucent rounded bottom-0 mb-5xl lg:mb-2xl z-50 hidden container md:w-auto md:p-0 md:ml-0 md:left-auto',
        styles.wrapper,
        popupVisible && styles.show,
        hidePopup && styles.hide,
      )}
      style={{ height: 50 }}
    >
      <div className="p-2sm flex w-full items-center justify-center">
        <div className="gap-xs flex">
          <Image
            src="/icons/icon_fire.png"
            alt=""
            className="w-2sm"
            style={{ height: 22 }}
          />
          <Text fontWeight="semibold">
            {numberOfInterested} {INTERESTED_POPUP_STRINGS.interested}
          </Text>
        </div>
      </div>
    </div>
  );
}
